import styled from "vue-styled-components";

const propsContent = {
    margin: {
        default: '0',
        type: String
    }
}

export const Content = styled('div', propsContent)`
    margin: ${props => props.margin};

    .link-tell-me-when-arrive {
        cursor: pointer;
        pointer-events: auto;
        &:hover {
            text-decoration: underline;
        }
    }
`;
